<template>
<div>
  <table>
    <thead class="loss-head">
      <th class="indice" >{{ $t('key') }}</th>
      <th id="th-variable" :class="{ 'variable' : !isKPI, 'variable-real' : isKPI }">{{ $t('descricao') }}</th>
      <th id="th-mapping" :class="{ 'mapping' : !isKPI, 'mappingKPI' : isKPI }">{{ isKPI ? $t('map-simulado') : $t('mapeamento-calculo')}}</th>
      <th v-if="isKPI" :class="{ 'mapping' : !isKPI, 'mappingKPI' : isKPI }">{{ $t('map-real') }}</th>
      <th v-if="configToUser" class="is-input" :title="$t('entrada')">{{ $t('e') }}</th>
      <th v-if="!configToUser" :class="{ 'value' : !isKPI, 'valueKPI' : isKPI }">{{ isKPI ? $t('valor-sim'): $t('valor')}}</th>
      <th v-if="isKPI" :class="{ 'value' : !isKPI, 'valueKPI' : isKPI }">{{ $t('valor-real') }}</th>
      <th class="action">{{ $t('acoes') }}</th>
    </thead>

    <tbody v-for="(model, i) in modelList" :key="i">
        <td id="indice" class="indice">
          {{i+1}}
        </td>
        
        <td id="td-variable" :class="{ 'variable' : !isKPI, 'variable-real' : isKPI }">
          <b-input id="input-variable" v-model="model.variable" type="text" />
        </td>

        <td id="td-mapping" :class="{ 'mapping' : !isKPI, 'mappingKPI' : isKPI }">
          <b-input id="input-mapping" v-model="model.mapping" type="text" />
        </td>

        <td v-if="isKPI" :class="{ 'mapping' : !isKPI, 'mappingKPI' : isKPI }">
          <b-input v-model="model.mappingReal" type="text" />
        </td>

        <td class="is-input" v-if="configToUser">
          <b-form-checkbox
            disabled
            v-model="model.type"
            value="I"
            unchecked-value="O"
          />
        </td>

        <td v-if="!configToUser">
          <p id="valueKPI" :class="{ 'value' : !isKPI, 'valueKPI' : isKPI }">{{ isKPI ? model.valueTarget : model.value }}</p>
        </td>

        <td v-if="isKPI">
          <p :class="{ 'value' : !isKPI, 'valueKPI' : isKPI }">{{ model.valueReal }}</p>
        </td>

        <td class="action">
          <img class="exec-calc" src="@/assets/assinarEconfirmar.png" :alt="$t('aplicar-calculo')" :title="$t('aplicar-calculo')" @click="execCalc(model)">
          <b-icon class="btn-icon btn-icon-remove ml-1" icon="dash-circle-fill" :title="$t('remover-indicador')" @click="askRemove(model, i)"/>
          <b-icon v-if="configToUser && model.type == 'I' && model.parentId != -9999 && typeof model.id != 'string'" class="btn-iconAdd ml-1"  :title="$t('adicionar-nova-entrada')" icon="plus-circle-fill" @click="addNewInput(i)" aria-hidden="true"/>
        </td>
    </tbody>
  </table>
  <b-modal
      id="askRemoveLossEfficiency"
      size="md"
      hide-footer
      :title="$t('alerta')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
        :question="`Deseja apagar ${transientModel.variable} da lista ?`"
        v-bind:action="remove"
        modelname="askRemoveLossEfficiency"
      />
    </b-modal>
</div>
</template>

<script>
import MessageBox from "@/components/template/MessageBoxModal.vue";
import Mapping from '../models/Mapping';

  export default {
    name:"tableLossAndEfficiency",
    props: ["modelList", "isKPI", "configToUser"],
    components: { MessageBox },
    data() {
      return {
        transientModel: {},
        index: -9
      }
    },

    inject: ["updateTags"],

    watch: {
      modelList(){
      },
    },

    methods: {
      addNewInput(index){
        

        let map = new Mapping({  variable: "Nova entrada", mapping:"", type: "I", operation: this.modelList[index].operation, parentId: this.modelList[index].parentId })
        
        this.modelList.splice(index+1, 0, map)
        this.$emit("modelChanged", this.modelList);
        this.$emit("addNewInput", map);
      },

      sendChange(){
        this.$emit("modelChanged", this.modelList);
      },

      askRemove(model, i){
        this.transientModel = model
        this.index = i
        this.$bvModal.show("askRemoveLossEfficiency");    
      },

      remove(){
        let modelToRemove = this.modelList.slice(this.index, this.index+1)
        let filtred = this.modelList.filter(k => k.type == "I" && k.parentId == modelToRemove[0].parentId)
       
        
        if(filtred.length == 1 || modelToRemove[0].type == "O" || typeof modelToRemove[0].id == "string")
          this.$emit("deleteModel", this.index);
        else{
          this.modelList.splice(this.index, 1)
          this.$emit("deleteSingleInput", modelToRemove[0]);
        }
      },

      execCalc(model){
        model.setValue()
        this.updateTags()
        this.sendChange()
      },
    },
  }
</script>

<style scoped>

table{
  width: 100%;
}

p{
  margin: 0;
}

.index{
  min-width: 10px;
  width: 2%;
}

.variable{
  min-width: 120px;
  width: 30%;
}

.variable-real{
  min-width: 90px;
  width: 20%;
}
.mapping{
  min-width: 120px;
  width: 48%;  
}

.mappingKPI{
  min-width: 50px;
  width: 28%;  
}

.is-input{
  display: flex;
  justify-content: center;
  align-items: center;
}
 
.is-input > div{
  width: 100%;
  height: 35px;
  padding-top: 6px;
  padding-left: 30px;
}

.value{
  min-width: 80px;
  width: 10%;
  text-align: right;
}

.valueKPI{
  min-width: 80px;
  width: 10%;
  text-align: right;
}
th.value{
  text-align: center;
}

th.valueKPI{
  text-align: center;
}

.action{
  min-width: 64px;
  width: 10%;
}

.exec-calc{
   width: 20px;
   cursor: pointer;
 }

 .btn-icon, .btn-iconAdd {
  font-size: 17px;
  cursor: pointer;
}

.btn-icon-remove{
  color: #f009
}


</style>